import React from 'react';

export default function (ComponentClass: React.ComponentClass | React.FC<any>) {
  return React.memo(ComponentClass, (prevProps, nextProps) => {
    if (prevProps.value === nextProps.value && prevProps.disabled === nextProps.disabled) {
      return true;
    }
    return false;
  });
}
